module.exports = __webpack_public_path__ + "media/fallback/quote-c61cc18f.png";